import { ageCategories } from "@/mocks/homeData";

export default function AgeCategorySection() {
  return (
    <section id="age" className="w-full py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        {/* Section Title */}
        <div className="flex items-center gap-2 mb-6 md:mb-8">
          <i className="ri-award-line text-primary-500 text-lg"></i>
          <h2 className="text-lg md:text-xl font-bold text-foreground-950">
            お子さんの年齢を教えてください
          </h2>
        </div>

        {/* Age Cards */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-7 gap-3 md:gap-4">
          {ageCategories.map((age) => (
            <a
              key={age.id}
              href={`#${age.id}`}
              className="group relative rounded-xl overflow-hidden bg-white border border-background-200 hover:border-primary-300 hover:shadow-md transition-all"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={age.image}
                  alt={age.label}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex items-center justify-between px-3 py-2.5">
                <span className="text-sm font-bold text-foreground-800">
                  {age.label}
                </span>
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}